import { render, staticRenderFns } from "./unauthLayout.vue?vue&type=template&id=c31aa398&"
import script from "./unauthLayout.vue?vue&type=script&lang=js&"
export * from "./unauthLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports